import React, { useEffect, useRef, useState, useContext } from 'react'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import Card from '../../../../Base/Components/Card/Card'
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';

import PosicionesCrudModal from './PosicionesCRUD/PosicionesCrudModal';
import { getPosicion } from '../../../../API/Suministros/SuministrosRequest';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';

const PosicionesScreen = ({ enModal = false }) => {
    const toast = useRef(null);
    const { config } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [posicion, setPosicion] = useState([]);
    const [selected, setSelected] = useState([]);
    const [showDialog, setShowDialog] = useState(false);

    const getInfo = async () => {
        setLoading(true);
        const d = await getPosicion();
        // console.log(d);
        setPosicion(d);
        setLoading(false);
    };

    const columns = [
        {
          header: "ID",
          headerEn:"ID",
          field: "IdPosicion",
          hidden: userAuth.IdRol === 1,
          className: "Xsmall",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "Nombre de Fila",
          headerEn:"Position Name",
          field: "NombrePosicion",
          className: 'XXXlarge',
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "No. de Fila",
          headerEn:"Position Number",
          field: "NumeroPosicion",
          className: 'small',
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        // {
        //   header: "Bandeja",
        //   headerEn:"Tray",
        //   field: "Bandeja",
        //   flex: 1,
        // },
        {
          header: "Bodega",
          headerEn:"Warehouse",
          field: "NombreBodega",
          className: 'XXlarge',
          body: (e) => e?.NombreBodega
        },
        {
          header: "Estante",
          headerEn:"Shelf",
          field: "NombreEstante",
          body: (e) => e?.NombreEstante
        },
        {
          header: "Estado",
          headerEn: "Status",
          field: "IdStatus",
          className: "small",
          Format: "Estado", 
          filter: false,    
          body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
        },
        {
          header: "User Edit",
          headerEn: "User Edit",
          field: "UserName",
          hidden: userAuth.IdRol === 1,
          className: "large",
        },
        {
          field: "IdPosicion",
          className: "",
          header: "",
          Format: "Botones",
          frozen: true,
          alignFrozen: "right",
          filter: false,
          Botones: [
            {
              icon: "pi pi-pencil",
              tooltip: "Editar",
              onClick: (rowData) => {
                setShowDialog(true);
                setSelected(rowData);
              },
            },
          ],
        },
    ]

    const table = {
        Columns: columns,
        Data: posicion,
        loading: loading
    };


    useEffect(() => {
      setTitlePage(getLabel(baseLang, "posicion", config.language));
      getInfo();
    }, []);



    return (
        <div
        className=" p-fluid px-4"
        style={{ width: "100%", height: "100%", margin: "auto" }}
        >
            <Toast ref={toast} />
            <Card
                titulo={
                <div className='botones'>
                    <h3>{getLabel(baseLang, "posicion", config.language)}</h3>
                    <Button icon='pi pi-refresh' onClick={getInfo} />
                    <Button icon='pi pi-plus' severity='success' onClick={() => {
                        setShowDialog(true);
                        setSelected(null);
                    }} />
                </div>}
                contenido={
                 <div className="p-4" style={{ height: enModal ? "60vh" : "90vh" }}>
                    <AgGrid table={table} />
                  </div>
                }
            />

            {showDialog && <PosicionesCrudModal toastRef={toast} posicionesDialog={showDialog} posicion={selected} setPosicionesDialog={setShowDialog} getPos={getInfo} modo={selected ? "Editar" : "Crear"}/>}

        </div>
    )
}

export default PosicionesScreen;

